// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import Responsive from 'react-responsive';
import cssVars from 'css-vars-ponyfill';

// Components
import TopMenuBar from './components/TopMenuBar';
import Menu from './components/Menu';
import OrganizationsList from './components/OrganizationsList';
import Map from './components/Map';
import MobileMap from './components/MobileMap';
import Settings from '../settings';
import BottomMenuBar from './components/BottomMenuBar';

// Actions
import { fetchUserLocation, loginGuestUser } from '../authentication/actions';
import { fetchMapLayersByProjCatTree } from './actions';

// Types and Shapes
import { userLocationShape, profileShape } from '../authentication/propTypesShapes';

// Assets
import './index.css';

// Constants
import { LEFT_PANE } from './constants';
import {
  UNAUTHORIZED_CSS_FILE_NAME
  // UNAUTHORIZED_GUEST_USER
} from '../shared/components/ErrorBoundary';

// Utils
import { isFirstRender } from '../shared/utils/data';
import { logToConsole } from '../shared/utils/log';
import { HTTP_STATUS_CODES } from '../shared/utils/httpError';


const tabPaneStyles = (hash) => {
  const styles = {};

  Object.keys(LEFT_PANE.HASH_LINK).forEach(hashLink => {
    styles[hashLink] = LEFT_PANE.HASH_LINK[hashLink] === hash ? 'show active' : '';
  });
  return styles;
};

const Mobile = props => <Responsive {...props} maxWidth={767.98} />;
const Default = props => <Responsive {...props} minWidth={768} />;

function changeCssFileName(cssFileName) {
  if (cssFileName) {
    const linkTag = document.getElementById('brand-style');
    const cssFileUrl = `${process.env.PUBLIC_URL}/assets/css/${cssFileName}`;

    //logToConsole('CSS File Url: ', cssFileUrl);
    linkTag.href = cssFileUrl;
  }

  cssVars({
    // Exclude Bootstrap CSS file
    exclude: '[href*=bootstrap],[href*=google]'
  });
}


class Home extends React.PureComponent {
  static propTypes = {
    gettingUserLocation: PropTypes.bool,
    userLocation: userLocationShape,
    loggedIn: PropTypes.bool,
    token: PropTypes.string,
    profile: profileShape,
    error: PropTypes.object
  };

  componentDidMount() {
    const { userLocation, dispatch } = this.props;

    if (!userLocation) {
      dispatch(fetchUserLocation());
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const {
      token, loggedIn, gettingUserLocation, userLocation, profile, dispatch
    } = newProps;
    const {
      gettingUserLocation: oldGettingUserLocation,
      profile: oldProfile
    } = this.props;

    // User location request has finished
    if (gettingUserLocation !== oldGettingUserLocation && !gettingUserLocation) {
      if (!loggedIn) {
        dispatch(loginGuestUser(userLocation || {}));
      }
    }

    if (profile !== oldProfile && profile) {
      const { data, zone } = profile;
      //const { cssFileName } = data.organization;
      const cssFileName = data.title;

      logToConsole('Org CSS File Name: ', cssFileName);
      if (cssFileName === UNAUTHORIZED_CSS_FILE_NAME) {
        throw new Error(UNAUTHORIZED_CSS_FILE_NAME);
      }
      changeCssFileName(cssFileName);

      dispatch(fetchMapLayersByProjCatTree(token, {
        isGlobal: false,
        zoneId: zone.id
      }));
    }
  }

  renderCopyright = () => {
    const today = new Date();

    return (
      <span
        className="Copyright"
        data-year={today.getFullYear()}
      />
    );
  };

  render() {
    const { token, profile, history, location, error } = this.props;

    if (error?.status === HTTP_STATUS_CODES.BAD_REQUEST
      || error?.status === HTTP_STATUS_CODES.UNAUTHORIZED) {
      // throw new Error(UNAUTHORIZED_GUEST_USER);
      throw new Error(error);
    }

    if ( isFirstRender(profile) ) {
      return null;
    }

    const { hash } = location;
    const tabStyles = tabPaneStyles(hash);
    const { zone } = profile;

    return (
      <div className="Home container-fluid m-0 p-0">
        <div className="d-flex flex-column flex-md-row">
          <div className="LeftPane d-flex flex-column">
            <TopMenuBar token={token} history={history} location={location} />
            <div className="LeftPaneContent tab-content">
              <div className={`tab-pane fade ${tabStyles[LEFT_PANE.HASH_LINK_HOME]}`}>
                <Default>
                  <Menu history={history} location={location} />
                </Default>
                <Mobile>
                  <Menu history={history} location={location} isOnMobileView />
                </Mobile>
              </div>
              <div className={`tab-pane fade ${tabStyles[LEFT_PANE.HASH_LINK_LISTING]}`}>
                <OrganizationsList history={history} location={location} />
              </div>
              <div className={`tab-pane fade ${tabStyles[LEFT_PANE.HASH_LINK_SETTINGS]}`}>
                <Settings />
              </div>
              <Mobile>
                <div className={`tab-pane fade ${tabStyles[LEFT_PANE.HASH_LINK_MAP]}`}>
                  <MobileMap
                    defaultCenter={zone.center}
                    defaultZoom={zone.defaultZoomLevel}
                    location={location}
                  />
                </div>
              </Mobile>
            </div>

            <div className="Footer d-flex flex-column justify-content-end">
              <Mobile>
                {(hash === LEFT_PANE.HASH_LINK.LISTING || hash === LEFT_PANE.HASH_LINK.MAP) ? (
                  <BottomMenuBar />
                ) : (
                  this.renderCopyright()
                )}
              </Mobile>
              <Default>
                {this.renderCopyright()}
              </Default>
            </div>
          </div>

          <Default>
            <div className='RoutesContainer flex-grow-1'>
              <Route exact path="/"
                render={(props) => (
                  <Map
                    defaultCenter={zone.center}
                    defaultZoom={zone.defaultZoomLevel}
                    {...props}
                  />
                )}
              />
            </div>
          </Default>
        </div>
      </div>
    );
  }
}

export default connect(({ authentication }) => ({
  gettingUserLocation: authentication.gettingUserLocation,
  userLocation: authentication.userLocation,
  loggedIn: authentication.loggedIn,
  token: authentication.token,
  profile: authentication.profile,
  error: authentication.error
}), null)(Home);
